import { useReduxState } from 'hooks';
import { ProgressCircle } from 'components/common';
import { Icon } from 'components/common/icons';

interface Props {
  progress: number;
}

const CompetencyMatrixMatchStatus = ({ progress }: Props) => {
  const { theme } = useReduxState();

  return (
    <div style={{ padding: '5px 0' }}>
      {progress === 1 ? (
        <Icon icon="check-circle" style={{ color: theme.successColor }} />
      ) : progress === 0 ? (
        <Icon
          icon="times-circle"
          style={{ color: theme.lightGreyDarkActive }}
        />
      ) : (
        <ProgressCircle
          backgroundColor="inherit"
          borderWidth={3}
          borderProgressColor={theme.warningStandaloneColor}
          progress={progress}
          style={{ display: 'flex', justifyContent: 'center' }}
          width={15}
        />
      )}
    </div>
  );
};

export default CompetencyMatrixMatchStatus;
